import { obtenirUrlControleur } from '../utils/urlUtils';
import fetch, { jsonHeaders } from '../utils/fetch';
import { AuthentificationResponse } from '../modeles/AuthentificationResponse';
import { ConnexionRequest } from '../modeles/ConnexionRequest';
import { InscriptionRequest } from '../modeles/InscriptionRequest';
import { MotDePasseOublieRequest } from '../modeles/MotDePasseOublieRequest';
import { ReinitialiserMotDePasseRequest } from '../modeles/ReinitialiserMotDePasseRequest';
import { RenouvellementTokenRequest } from '../modeles/RenouvellementTokenRequest';

const lienAuthentification = obtenirUrlControleur('auth');

export default class AuthentificationApi {
	static async inscrire(inscriptionRequest: InscriptionRequest): Promise<AuthentificationResponse> {
		return await fetch(`${lienAuthentification}/api/auth/inscription`, {
			method: 'POST',
			headers: jsonHeaders,
			body: JSON.stringify(inscriptionRequest)
		}) as AuthentificationResponse;
	}

	static async connecter(connexionRequest: ConnexionRequest): Promise<AuthentificationResponse> {
		return await fetch(`${lienAuthentification}/api/auth/connexion`, {
			method: 'POST',
			headers: jsonHeaders,
			body: JSON.stringify(connexionRequest)
		}) as AuthentificationResponse;
	}

	static async renouvelerToken(request: RenouvellementTokenRequest): Promise<AuthentificationResponse> {
		return await fetch(`${lienAuthentification}/api/auth/renouvellement`, {
			method: 'POST',
			headers: jsonHeaders,
			body: JSON.stringify(request)
		}) as AuthentificationResponse;
	}

	static async deconnecter(refreshToken: string, accessToken: string): Promise<void> {
		const headers = {
			...jsonHeaders,
			...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {})
		};

		await fetch(`${lienAuthentification}/api/auth/deconnexion`, {
			method: 'POST',
			headers,
			body: JSON.stringify({ refreshToken })
		});
	}

	static async confirmerCourriel(token: string): Promise<void> {
		const tokenEncode = encodeURIComponent(token);
		await fetch(`${lienAuthentification}/api/auth/confirmer-courriel?token=${tokenEncode}`, {
			method: 'GET',
			headers: jsonHeaders
		});
	}

	static async motDePasseOublie(request: MotDePasseOublieRequest): Promise<void> {
		await fetch(`${lienAuthentification}/api/auth/mot-de-passe-oublie`, {
			method: 'POST',
			headers: jsonHeaders,
			body: JSON.stringify(request)
		});
	}

	static async reinitialiserMotDePasse(reinitialiserMotDePasseRequest: ReinitialiserMotDePasseRequest): Promise<void> {
		await fetch(`${lienAuthentification}/api/auth/reinitialiser-mot-de-passe`, {
			method: 'POST',
			headers: jsonHeaders,
			body: JSON.stringify(reinitialiserMotDePasseRequest)
		});
	}
}
